// extracted by mini-css-extract-plugin
module.exports = {"teamHeading":"ourteamstyles_teamHeading__1SJ-A","ourTeamCards":"ourteamstyles_ourTeamCards__rLSnz","teamWrapper":"ourteamstyles_teamWrapper__2Ql2w"};